import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pb-1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-3" }, " Wunschkennzeichen.de - In 3 einfachen Schritten zu Ihren Wunschkennzeichen ")
  ])
], -1)
const _hoisted_4 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
], -1)
const _hoisted_6 = [
  _hoisted_5
]

import HomeInput from '@/components/HomeInput.vue';
import StepBox from '@/components/StepBox.vue';
import CopyText from '@/components/CopyText.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HomeInput),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(StepBox),
        _createVNode(CopyText)
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true)
  ], 64))
}
}

})